<template>
  <div class="myTableSearch">
    <myTitleName style="margin-bottom: 16px;" :titleName="titleName" v-if="titleName">
      <template slot="titleRight" v-if="$slots.tableTitleRight">
        <slot name="tableTitleRight"></slot>
      </template>
      <div class="screen" v-if="formData.length > 4" @click="isScreen = !isScreen">
        筛选
        <img v-if="isScreen" src="@/assets/images/arrowUp.png" alt="">
        <img v-else src="@/assets/images/arrowDown.png" alt="">
      </div>
    </myTitleName>
    <el-form class="search" label-suffix="：">
      <div id="searchCon" class="searchCon" ref="searchCon" style="overflow: hidden;"
        :style="{ maxHeight: isScreen ? '56px' : 'max-content' }">
        <el-row :gutter="21" style="flex-wrap: wrap;" type="flex" v-if="formData.length">
          <el-col :key="index" :lg="item.colLg ||colLg" :md="12" :sm="24" v-for="(item, index) in   formData  ">
            <!-- 输入框 -->
            <el-form-item :label="item.label" :label-width="setLabelNameSize(item.label)" v-if="item.type == 'input'">
              <el-input :placeholder="'请输入' + (item.placeholder ? item.placeholder : item.label)" clearable
                v-model="item.value" :maxlength="item.maxlength"></el-input>
            </el-form-item>
            <!-- 下拉选择器 -->
            <el-form-item :label="item.label" :label-width="setLabelNameSize(item.label)" v-if="item.type == 'select'">
              <el-select :placeholder="'请选择' + item.label" clearable style="width:100%" v-model="item.value" @change="(e)=>item.change && item.change(e,item)"
              :filterable="item.filterable" :remote="item.remote" :remote-method="(e)=>item.remoteMethod && item.remoteMethod(e,item)">
                <el-option :key="idx" :label="(item.optionLabel ? ele[item.optionLabel] : ele.dictLabel)"
                  :value="item.optionValue ? ele[item.optionValue] : ele.dictValue"
                  v-for="(ele, idx) in item.data"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="item.label" :label-width="setLabelNameSize(item.label)" v-if="item.type == 'date'">
              <el-date-picker v-model="item.value" placeholder="选择日期" style="width: 100%;"
                :value-format="item.format || 'yyyy-MM-dd'">
              </el-date-picker>
            </el-form-item>
            <!-- 日期范围选择器 -->
            <el-form-item :label="item.label" :label-width="setLabelNameSize(item.label)" v-if="item.type == 'daterange'">
              <el-date-picker :end-placeholder="item.label+'结束日期'" range-separator="至" :start-placeholder="item.label+'开始日期'" style="width: 100%;"
                :value-format="item.format || 'yyyy-MM-dd'" type="daterange" v-model="item.value"></el-date-picker>
            </el-form-item>
            <!-- 日期时间范围选择器 -->
            <el-form-item :label="item.label" :label-width="setLabelNameSize(item.label)"
              v-if="item.type == 'datetimerange'">
              <el-date-picker end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" style="width: 100%;"
                type="datetimerange" v-model="item.value"></el-date-picker>
            </el-form-item>
             <!-- 月范围选择器 -->
            <el-form-item :label="item.label" :label-width="setLabelNameSize(item.label)" v-if="item.type=='monthrange'">
              <el-date-picker v-model="item.value" :value-format="item.format || 'yyyy-MM'" type="monthrange" range-separator="至" style="width: 100%;" start-placeholder="开始月份" end-placeholder="结束月份"></el-date-picker>
            </el-form-item>
            <!-- 年选择器 -->
            <el-form-item :label="item.label" :label-width="setLabelNameSize(item.label)" v-if="item.type == 'year'">
              <el-date-picker placeholder="选择年" :value-format="item.format || 'yyyy'" style="width: 100%;" type="year"
                v-model="item.value">
              </el-date-picker>
            </el-form-item>
            <!-- 级联选择器 -->
            <el-form-item :label="item.label" :label-width="setLabelNameSize(item.label)" v-if="item.type == 'cascader' && item.data">
            <el-cascader
              v-model="item.value"
              :placeholder="'请选择' + item.label" :disabled="item.disabled" clearable style="width:100%"
              :options="item.data ||[]"
              :props="item.props"
              :ref="item.key"
              :key="item.key"
              :show-all-levels="item.showAllLevels??true"
              @change="(e)=>item.change && item.change(e,item,$refs[item.key])"
            ></el-cascader>
            </el-form-item>
            <!-- 月选择器 -->
            <el-form-item :label="item.label" :label-width="setLabelNameSize(item.label)" v-if="item.type == 'month'">
              <el-date-picker v-model="item.value" :value-format="item.format || 'yyyy-MM'" style="width: 100%;"
                type="month" placeholder="选择月"></el-date-picker>
            </el-form-item>
            <!-- 数字输入框（带增减按钮） -->
            <el-form-item :label="item.label" :label-width="setLabelNameSize(item.label)" v-if="item.type == 'number'">
              <el-input-number 
                v-model="item.value" 
                :placeholder="'请输入' + (item.placeholder ? item.placeholder : item.label)" 
                :min="item.min" 
                :max="item.max"
                :step="item.step || 1"
                :precision="item.precision"
                :controls-position="item.controlsPosition"
                style="width: 100%;"
                :disabled="item.disabled"
              ></el-input-number>
            </el-form-item>
            <!-- 只能输入数字的输入框 -->
            <el-form-item :label="item.label" :label-width="setLabelNameSize(item.label)" v-if="item.type == 'numberInput'">
              <el-input 
                :placeholder="'请输入' + (item.placeholder ? item.placeholder : item.label)" 
                clearable
                v-model="item.value"
                @input="handleNumberInput($event, item)"
                :maxlength="item.maxlength"
              ></el-input>
            </el-form-item>
           
            <!--   插槽   -->
            <el-form-item :label="item.name" :label-width="setLabelNameSize(item.name)" v-if="item.type === 'slot'">
              <slot :item="item" :name="item.slotName" :row="item" />
            </el-form-item>

            <!--   样式兼容插槽   -->
            <el-form-item :label="item.name" :label-width="setLabelNameSize(item.name)" class="custom-label"
              v-if="item.type === 'blockSlot'">
              <slot :item="item" :name="item.slotName" :row="item" />
            </el-form-item>
          </el-col>

          <el-col :lg="searchColLg" :md="12" :sm="24"
            :class="titleName && formData.length > 4 ? 'isScreenSearchOperate' : 'searchOperate'">
            <el-form-item label-width="0px">
              <el-button @click="handleSearch" icon="el-icon-search" size="mini" type="primary">搜索</el-button>
              <el-button @click="searchReset" icon="el-icon-refresh" size="mini">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row :gutter="21" style="flex-wrap: wrap;" type="flex" v-if="isSearchOperate">
              <el-col :lg="24" :md="24" :sm="24">
                <slot name="searchOperate"></slot>
              </el-col>
            </el-row> -->
      </div>
    </el-form>
    <div class="line" v-if="formData.length && isTool"></div>
    <div class="tableTool" v-if="formData.length && isTool">
      <slot name="tool"></slot>
      <div v-if="!$slots.tool"></div>
      <!-- <div class="toolIcon">
        <img @click="searchReset" alt="" src="@/assets/refresh.png">
        <el-popover>
          <img alt="" slot="reference" src="@/assets/tool.png" style="display: list-item;">
          <el-checkbox-group class="tableShowlabel" v-model="tableShowlabel">
            <el-checkbox :disabled="tableShowlabel.length === 1 && ele.prop === tableShowlabel[0].prop" :key="idx"
              :label="ele" class="tableShowlabelItem" v-for="(ele, idx) in tableLabel">{{ ele.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </div> -->
    </div>

    <div class="table">
      <el-table :cell-style="cellStyle" :data="tableData" :header-cell-style="headerStyle" :row-class-name="rowClassName"
        @row-click="rowClick" @selection-change="tableSelectChange" ref="table" :row-key="rowKey" style="width: 100%"
        @cell-click="cellClick" v-loading="loading">
        <el-table-column type="selection" v-if="isSelection" reserve-selection align="center"
          width="55"></el-table-column>
        <el-table-column :index="typeIndex" align="center" label="序号" type="index" v-if="isIndex"
          width="55"></el-table-column>
        <template v-for="(item, index) in tableShowlabel">
          <!-- 插槽格式化table -->
          <el-table-column :align="item.align || 'center'" :key="index" :label="item.label" :prop="item.prop"
            :show-overflow-tooltip="item.isTooltip!=undefined?item.isTooltip: true" :width="item.width" :min-width="item.minWidth" v-if="!item.formatter">
            <template slot-scope="scope">
              <slot :label="item" :name="item.prop" :row="scope.row" :rowIndex="scope.$index" ref="slot">
                {{
                  scope.row[item.prop] === null || scope.row[item.prop] === undefined || scope.row[item.prop] === ''
                  ? '-' : scope.row[item.prop] }}
              </slot>
            </template>

            <!-- 二级头部 -->
            <template v-if="item.children">
              <el-table-column v-for="(child, childIndex) in item.children || []" :align="child.align || 'center'"
                :key="childIndex" :label="child.label" :prop="child.prop" :show-overflow-tooltip="child.isTooltip || true"
                :width="child.width">
                <template slot-scope="scope">
                  <slot :label="child" :name="child.prop" :row="scope.row" :rowIndex="scope.$index" ref="slot">
                    {{
                      scope.row[child.prop] === null || scope.row[child.prop] === undefined || scope.row[child.prop] === ''
                      ? '-' : scope.row[child.prop] }}
                  </slot>
                </template>
                <!-- 三级头部 开始-->
                <template v-if="child.children">
                  <el-table-column v-for="(childC, childCIndex) in child.children || []" :align="childC.align || 'center'"
                    :key="childCIndex" :label="childC.label" :prop="childC.prop" :show-overflow-tooltip="childC.isTooltip || true"
                    :width="childC.width">
                    <template slot-scope="scope">
                      <slot :label="childC" :name="childC.prop" :row="scope.row" :rowIndex="scope.$index" ref="slot">
                        {{
                          scope.row[childC.prop] === null || scope.row[childC.prop] === undefined || scope.row[childC.prop] === ''
                          ? '-' : scope.row[childC.prop] }}
                      </slot>
                    </template>
                  </el-table-column>
                </template>
                <!-- 三级头部 结束-->
              </el-table-column>
            </template>
          </el-table-column>
          <!-- formatter格式化table -->
          <el-table-column :align="item.align || 'center'" :formatter="item.formatter" :key="index" :label="item.label"
            :min-width="item.minWidth" :prop="item.prop" :show-overflow-tooltip="item.isTooltip || true"
            :width="item.width" v-else>
          </el-table-column>
        </template>

        <el-table-column :width="operateWidth" align="center" fixed="right" label="操作" v-if="isOperate">
          <template slot-scope="scope">
            <slot :row="scope.row" name="operate"></slot>
          </template>
          <!-- <template slot-scope="scope">
                                  <el-button type="text" size="small">查看</el-button>
                                  <el-button type="text" size="small">
                                      <span style="color: #F14A3F;">人员标注</span>
                                  </el-button>
                              </template> -->
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <!-- v-show="queryParams.total>queryParams.pageSize" -->
    <div class="pagination" v-if="isPagination">
      <el-pagination :current-page="queryParams.pageNum" :layout="'total,prev,pager,next'"
        :page-size="queryParams.pageSize" :page-sizes="queryParams.pageSizes" :total="total"
        @current-change="handleCurrentChange" @size-change="handleSizeChange" background hide-on-single-page />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 头部名称
    titleName: {
      type: String,
      default: ''
    },
    //请求接口
    queryFn: {
      type: Function,
      required: true,
    },
    // 数据选择
    tableSelectChange: {
      default: Function
    },
    // 搜索宽度
    colLg: {
      type: [String, Number],
      default: 6
      // default: 5
    },
    searchColLg: {
      type: [String, Number],
      // default: 6
      default: 4
    },
    // 操作区域
    isTool: {
      type: Boolean,
      default: true
    },
    //table操作
    isOperate: {
      type: Boolean,
      default: false
    },
    //table操作宽度
    operateWidth: {
      type: [String, Number],
      default: '120'
    },
    //序号
    isIndex: {
      type: Boolean,
      default: true
    },
    //多选
    isSelection: {
      type: Boolean,
      default: false
    },
    rowKey: {
      type: [String, Function],
      default: 'id'
    },
    formData: {
      type: Array,
      default: () => []
    },
    tableLabel: {
      type: Array,
      default: () => []
    },
    // 是否展示分页
    isPagination: {
      type: Boolean,
      default: true
    },
    rowClassName: {
      default: null
    },
    diyTableData: {
      default: () => {
        return []
      }
    },
    dataRow:{
      default:'rows'
    },  
    // 分页相关参数
    queryParams: {
      type: Object,
      default: () => {
        return {
          pageNum: 1,//当前页
          pageSize: 10,//一页数量
          pageSizes: [10, 20, 50, 100]
        }
      }
    },
    labelNameWidth:{
      type: [String, Number],
      default: '180px'
    }
  },
  data() {
    return {
      // 搜索折叠展开
      isScreen: false,
      tableShowlabel: [],
      total: 0,//总数
      tableData: [],
      form: {},
      element: {},
      loading: false,
      lastSearchParams: {}//保存最后一次搜索条件，用于分页时携带
    }
  },
  watch: {
    titleName: {
      handler(val) {
        if (val && this.formData.length > 4) {//有标题显示筛选
          this.isScreen = true;
        } else {
          this.isScreen = false;
        }
      },
      immediate: true,
    },
    diyTableData: {
      handler(val) {
        if (val && val.length > 0) {
          this.initTableData({}, false)
        }
      },
      immediate: true,
      deep: true,
    },
    tableLabel: {
      handler: function (val) {
        // console.log('tableLabel', val)
        // console.log('tableLabel', this.tableLabel)
        this.tableShowlabel = val
      },
      immediate: true,
      deep: true,
    },
    queryFn: {
      handler(val) {
        if (val) {
          this.initTableData({}, false)
        }
      }
    },
  },
  created() {
    // this.tableShowlabel = this.tableLabel;
    // 初始化搜索
    this.initFormData()
    //初始化table数据
    this.initTableData({}, false)
  },
  methods: {
    //table数据
    initTableData(param, reset = false) {
      this.queryParams.query = param || {}
      // 格式化搜索字段
      this.$emit('recombinationData', param, (newParam) => {
        if (newParam !== undefined) this.queryParams.query = newParam
      }, reset)
      
      // 保存搜索条件用于分页
      if (param && Object.keys(param).length > 0) {
        this.lastSearchParams = { ...param }
      }
      
      if (this.queryFn) {
        this.loading = true
        this.queryFn(this.queryParams).then(res => {
          if (res && res.code == 200 && res.data) {
            // 如果不需要分页，data直接是数组
            if (Array.isArray(res.data)) {
              this.tableData = res.data
              this.total = res.data.length
              this.$emit('successQuery', { rows: res.data, total: res.data.length })
            } else {
              // 如果需要分页，data是对象格式 { rows: [], total: number }
              this.tableData = this.dataRow ? res.data[this.dataRow] : (res.data.rows || res.data)
              this.total = Number(res.data.total || res.data.length || 0)
              this.$emit('successQuery', res.data)
            }
          }
        }).catch(err => {
          console.log('请求出错', err)
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.total = this.diyTableData.length
        this.tableData = this.diyTableData.slice((this.queryParams.pageNum - 1) * this.queryParams.pageSize, this.queryParams.pageNum * this.queryParams.pageSize)
        this.$emit('successQuery', this.tableData)
      }
    },
    handleSizeChange(pageSize) {
      this.queryParams.pageSize = pageSize
      this.initTableData(this.lastSearchParams, false)
    },
    //分页事件
    handleCurrentChange(pageNum) {
      this.queryParams.pageNum = pageNum
      this.initTableData(this.lastSearchParams, false)
    },
    rowClick(row) {
      this.$emit('rowClick', row)
    },
    cellClick(row, column, cell, event) {
      this.$emit('cellClick', row, column, cell, event)
    },
    reload() {// 重新加载
      this.handleSearch()
    },

    // 查询数据
    handleSearch(reset) {
      const param = this.assembleSearchData();
      // this.$emit('initTableData', param, reset)
      this.initTableData(param, reset)
    },

    // 重置数据
    // isRequire为true 赋值value
    searchReset() {
      this.form.map((item, idx) => {
        switch (item.type) {
          case 'radio':
          case 'input':
          case 'select':
          case 'blockSlot':
          case 'cascader':
          case 'numberInput':
            item.value = ''
            break
          case 'year':
          case 'month':
          case 'date':
          case 'slot':
            item.value = ''
            break
          case 'number':
            item.value = null
            break
          case 'checkbox':
            item.value = []
            break
          case 'datetimerange':
          case 'daterange':
          case 'monthrange':
            item.value = []
            break
        }
      })
      this.queryParams.pageNum = 1
      this.lastSearchParams = {}
      this.initTableData({}, true)
    },

    // 组装查询/重置数据
    assembleSearchData() {
      const param = {};
      this.form.forEach(item => {
        if ((typeof item.value === 'string' && item.value) || (typeof item.value === 'number') || (item.value && typeof item.value === 'object' && item.value.length !== 0)) {
          const value = item.screen !== undefined ? item.screen(item.value) : item.value
          if (item.screen !== undefined && typeof value === 'object' && value !== null) {
            Object.assign(param, value)
          } else {
            param[item.key] = value
          }
        }
      })
      return param
    },
    // 处理数字输入，只允许输入数字
    handleNumberInput(value, item) {
      // 只保留数字，移除其他字符
      let numericValue = value.replace(/[^\d]/g, '')
      if (item.maxlength) {
        numericValue = numericValue.slice(0, item.maxlength)
      }
      if (numericValue !== value) {
        this.$set(item, 'value', numericValue)
      }
    },
    //列表序号
    typeIndex(index) {
      if(this.queryParams&&this.queryParams.pageNum ){
        return index + (this.queryParams.pageNum - 1) * this.queryParams.pageSize + 1
      }else{
        return index + 1;
      }
    },
    headerStyle() {
      return 'background: rgba(249,249,249, 1);color: #2A3347;font-size: 14px; height: 48px; border-bottom: 1px solid rgba(233, 233, 233, 1);'
    },

    // 搜索宽度
    setLabelNameSize(str) {
      return this.labelNameWidth;
      return `${str.length * 14 + 27}px`
    },
    // 初始化搜索form
    initFormData() {
      this.form = this.formData.map(item => {
        if (item.requestType === 'dict') {
          // 请求字典
          this.getDicts(item.dictName).then(res => {
            if (res && res.code == 200 && res.data) {
              item.data = res.data;
            }
          })
        } else if (item.requestType === 'port') {// 请求接口

        }

        this.$set(this, 'element', item)
        switch (item.type) {
          case 'radio':
          case 'input':
          case 'select':
          case 'numberInput':
        
            this.$set(this.element, 'change', item.change ? item.change : new Function())
          case 'year':
          case 'month':
          case 'date':
          case 'slot':
          case 'blockSlot':
          case 'cascader':
          case 'number':
            this.$set(this.element, 'value', item.value !== undefined ? item.value : (item.type === 'number' ? null : ''))
            break
          case 'checkbox':
            this.$set(this.element, 'value', [])
            break
          case 'datetimerange':
          case 'daterange':
          case 'monthrange':
            this.$set(this.element, 'value', [])
            break
        }
        return this.element
      })
    },
    cellStyle() {
      return 'color: #2A3347;font-size: 14px;border-bottom: 0.5px solid #eaebedff;padding: 10px 0;'
    },
  },
}
</script>

<style lang="scss" scoped>
.tableShowlabel {
  cursor: pointer;
  padding: 0 10px;
  display: flex;
  flex-direction: column;

  .tableShowlabelItem {
    padding: 5px 0px;
  }
}

.myTableSearch {
  padding: 24px 16px;
  border-radius: 5px;
  background: #ffffff;
  height: 100%;
  display: flex;
  flex-direction: column;

  .screen {
    margin-left: 32px;
    width: 80px;
    height: 30px;
    border-radius: 3px;
    background: rgba(24, 144, 255, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 1);
    font-family: OPPOSans;
    font-weight: bold;
    font-size: 12px;

    img {
      width: 24px;
      height: 24px;
    }

    cursor: pointer;
  }

  .isScreenSearchOperate {
    position: absolute;
    top: 0;
    right: 0;
  }


  .searchOperate,
  .isScreenSearchOperate {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    height: 100%;

    .el-button {
      height: 40px;
    }
  }

  .line {
    margin: 0px 0 16px;
    width: 100%;
    height: 1px;
    background-color: #d1d5dc;
  }

  .tableTool {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;


    .toolIcon {
      display: flex;
      align-items: center;

      img {
        width: 24px;
        height: 24px;
        margin-left: 16px;
        cursor: pointer;
      }
    }
  }

  .table {
    flex: 1;
    overflow: auto;
    width: 100%;
    // margin-top: 24px;
  }

  .pagination {
    display: flex;
    justify-content: end;
    margin-top: 10px;
  }
}

::v-deep.el-date-editor .el-range-separator {
  width: 10%;
}

/deep/ .el-form-item__label {
  color: rgba(42, 51, 71, 1);
  font-family: OPPOSans;
  font-weight: bold;
  font-size: 14px;
}

/deep/ .el-table__header-wrapper .el-table-column--selection .cell {
  padding-left: 12px !important;
}

/deep/ .el-input__inner {
  background: #f7f7f7ff;
  border: 0;
}

/deep/ .el-select .el-input__inner {
  background: #f7f7f7ff;
  border: 0;
}

/deep/ .el-date-editor .el-input__inner {
  background: #f7f7f7ff;
  border: 0;
}

/deep/ .el-date-editor .el-range-input {
  background: #f7f7f7ff;
}

/deep/ .el-cascader .el-input__inner {
  background: #f7f7f7ff;
  border: 0;
}

/deep/ .el-table__header th {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid rgba(233, 233, 233, 1) !important;
}
</style>
